export default "__VITE_ASSET__3YfN_v2r__"